import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('detailsViewEntityMenu');

    return {
        APPLICATION: t('application'),
        BATTERY: ({ count }: { count: number }) => t('battery', { count }),
        BOUNDARY: ({ count }: { count: number }) => t('boundary', { count }),
        CHEMICAL: t('chemical'),
        CITY: t('city'),
        CLASSIFICATION: t('classification'),
        CLIENT: t('client'),
        CONTACT_NAME: t('contactName'),
        CONTROLLER_SERIAL_NUMBER: t('controllerSerialNumber'),
        CROP: t('crop'),
        DRONE: ({ count }: { count: number }) => t('drone', { count }),
        DRONE_SERIAL_NUMBER: t('droneSerialNumber'),
        EMAIL: t('email'),
        EPA_NUMBER: t('epaNumber'),
        ESTIMATED_ACRES: t('estimatedAcres'),
        FAA_REGISTRATION_NUMBER: t('faaRegistrationNumber'),
        FARM: ({ count }: { count: number }) => t('farm', { count }),
        FIELD: ({ count }: { count: number }) => t('field', { count }),
        FLIGHT_CONTROLLER_FIRMWARE_VERSION: t('flightControllerFirmwareVersion'),
        FLIGHT_HOURS: t('flightHours'),
        FORMULATION: t('formulation'),
        MANUFACTURER: t('manufacturer'),
        MIX: t('mix'),
        MODE_OF_ACTION: t('modeOfAction'),
        NUMBER_OF_FLIGHTS: t('numberOfFlights'),
        PHONE: t('phone'),
        PILOT: ({ count }: { count: number }) => t('pilot', { count }),
        PPE: t('ppe'),
        PPE_REENTRY: t('ppeReentry'),
        RAINFASTNESS: t('rainfastness'),
        REI: t('rei'),
        ROLE: t('role'),
        SCHEDULED_PILOT: ({ count }: { count: number }) => t('scheduledPilot', { count }),
        SERIAL_NUMBER: t('serialNumber'),
        SIGNAL_WORD: t('signalWord'),
        STATE: t('state'),
        STATUS: t('status'),
        TARGET_PEST: t('targetPest'),
        TOTAL_ACRES: t('totalAcres'),
        TOTAL_AREA_APPLIED: t('totalAreaApplied'),
        TOTAL_VOLUME_APPLIED: t('totalVolumeApplied'),
        USER: t('user'),
        WARRANTY_END_DATE: t('warrantyEndDate'),
        WARRANTY_REMAINING: t('warrantyRemaining'),
        WARRANTY_START_DATE: t('warrantyStartDate'),
        ZIP: t('zip')
    };
};

export default useTranslation;
